import { api } from '../services/api';
export const getLastNPSScore = (userId, options) => api.get(`/users/${userId}/nps`, options);
export const postNPS = (userId, body) => api.post(`/users/${userId}/nps`, {
    body,
});
